module.exports = {
	"scheduleEditor": {
		"title": "Edit Availability",
		"legend": {
			"title": "Color Legend",
			"privateUse": "Private Use",
			"available": "Available for Rent",
			"past": "Was Available (Read Only)",
			"nonRepeating": "Non-Repeating",
			"variation": "Variation",
			"shutdown": "Temporary Shutdown",
			"new": "New (Not yet saved)",
			"preorder": "Pre-oreder reservation"
		},
		"deleteDialog": {
			"title": "Delete Range",
			"fromDate": "From Date",
			"fromTime": "Time",
			"toDate": "To Date",
			"toTime": "Time"
		},
		"confirmDelete": {
			"title": "Delete recurring schedule",
			"message": "Would you like to delete only this event, all events in the series, or this and all future events in the series?",
			"once": {
				"buttonText": "Only this instance",
				"description": "All other events in the series will remain.",
				"help": " "
			},
			"following": {
				"buttonText": "All following",
				"description": "This and all the following events will be deleted.",
				"help": " "
			},
			"all": {
				"buttonText": "All events in the series",
				"description": "All events in the series will be deleted.",
				"help": " "
			}
		},
		"confirmEdit": {
			"title": "Edit recurring schedule",
			"message": "Would you like to change only this event, all events in the series, or this and all following events in the series?",
			"once": {
				"buttonText": "Only this event",
				"description": "All other events in the series will remain the same.",
				"help": " "
			},
			"following": {
				"buttonText": "Following events",
				"description": "This and all the following events will be changed.",
				"help": "Any changes to future events will be lost."
			},
			"all": {
				"buttonText": "All events",
				"description": "All events in the series will be changed.",
				"help": "Any changes made to other events will be kept."
			}
		},
		"editDialog": {
			"title": "View",
			"addMode.title": "Add Schedule",
			"viewMode.title": "View Schedule",
			"fromDate": "From date",
			"fromTime": "From",
			"toDate": "To date",
			"toTime": "To",
			"recurring": "Repeats",
			"description": {
				"DAILY": "Repeat every day",
				"WEEKLY": "Repeat every week on",
				"MONTHLY": "Repeat on the {{date}} of every month",
				"YEARLY": "Repeats on {{date}} of every year",
				"until": "until",
				"forever": "forever"
			},
			"overrideVariants": "Override Variants",
			"warnEditingPast": "Note! Past events cannot be changed. Changes only apply to future events."
		}
	},
	"alert": {
		"top": {
			"name": "Top Alerts"
		},
		"emergency": {
			"name": "Emergency",
			"title": "Emergency Lease #{{id}}",
			"description": "{{phone1}} - {{name}}<br> <span dir='rtl'>{{address1}} ({{pollLabel}})</span><br> call at {{createdAt}}"
		},
		"deadSensor": {
			"name": "Dead Sensors",
			"title": "Dead Sensors Spot #{{id}}",
			"description": "<span dir=\"rtl\">{{address1}} ({{pollLabel}})</span>"
		},
		"lowBattery": {
			"name": "Low Battery",
			"title": "Low Battery Spot #{{id}}",
			"description": "<span dir='rtl'>{{address1}} ({{pollLabel}})</span><br> battery level {{batteryLevel}}"
		},
		"longRent": {
			"name": "Long Rent",
			"title": "Long Lease Lease #{{id}}",
			"description": "{{phone1}} - {{name}}<br> <span dir='rtl'>{{address1}} ({{pollLabel}})</span><br> started at {{start}}"
		},
		"leaseNotStarted": {
			"name": "Lease Not Started",
			"title": "Unactivated Preorder Lease #{{id}}",
			"description": "{{phone1}} - {{name}}<br> <span dir='rtl'>{{address1}} ({{pollLabel}})</span><br> reserved for {{reservedStart}}"
		},
		"fullLot": {
			"name": "Full Lot",
			"title": "Full lot #{{id}} - {{name}}",
			"description": "Currently {{numOfLeases}} out of {{numOfSpots}} spots are leased"
		},
		"disabledLot": {
			"name": "Disabled Lot",
			"title": "Disabled Lot #{{id}} - {{name}}",
			"description": "All of the lot's spots are currently turned off"
		},
		"preorderInvader": {
			"name": "Preorder Invader",
			"title": "Invasion Spot #{{id}}",
			"description": "<span dir='rtl'>{{address1}} ({{pollLabel}})</span><br> invasion at {{commLogCreatedAt}}<br> preordered for {{reservedStart}}<br> by {{phone1}} - {{name}}"
		},
		"invader": {
			"name": "Invader",
			"title": "Invader in {{address1}} Spot #{{id}}",
			"description": "From {{commLogCreatedAt}}"
		}
	},
	"DayOfWeek": {
		"0": "Monday",
		"1": "Tuesday",
		"2": "Wednesday",
		"3": "Thursday",
		"4": "Friday",
		"5": "Saturday",
		"6": "Sunday",
		"short": {
			"0": "Mon",
			"1": "Tue",
			"2": "Wed",
			"3": "Thu",
			"4": "Fri",
			"5": "Sat",
			"6": "Sun"
		}
	},
	"RepeatType": {
		"0": "Daily",
		"1": "Weekly",
		"2": "Monthly",
		"3": "Yearly"
	},
	"button": {
		"ok": "Ok",
		"save": "Save",
		"reset": "Reset",
		"add": "Add",
		"delete": "Delete",
		"legend": "Legend",
		"cancel": "Cancel",
		"close": "Close",
		"help": "Help"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/shared/translator/translations-en.config.yml
 ** module id = 903
 ** module chunks = 0
 **/